import moment from "moment";
import {
  CHANGE_DATE_RANGE,
  HANDLE_ERRORS
} from "./types";

import { push } from "connected-react-router";

const maxWeeks = 1;
const oneWeekErrorMessage = 'Sorry, date range is too large, resizing now to one week!';

const limitDateRange = dateRange => {
  let { startDate, endDate } = dateRange;

  const currentDuration = Math.abs(endDate.unix() - startDate.unix()) * 1000;

  const maxWeeksDuration = moment.duration({ weeks: maxWeeks, days: 1 }).asMilliseconds();

  if (currentDuration > maxWeeksDuration) {
    const startRef = startDate.clone();
    endDate = startRef.add(maxWeeks, "w");
    return {
      startDate,
      endDate
    };
  }

  return dateRange;
};

export const changeDateRange = (dateRange, realtime) => async (dispatch, getState) => {
  // limit dates range to 15 days
  const limitedDateRange = limitDateRange(dateRange);
  const { startDate, endDate } = limitedDateRange;

  if (limitedDateRange.endDate.unix() < dateRange.endDate.unix()) {
    // it means the date range has been resized, thus display message
    dispatch({
      type: HANDLE_ERRORS,
      payload: {
        message: oneWeekErrorMessage,
        open: true
      }
    });
  }

  // Dispatch push
  if(!realtime) {
    dispatch(push(`/dashboard?startDate=${startDate.valueOf()}&endDate=${endDate.valueOf()}`));
  } else {
    dispatch(push(`/dashboard`));
  }

  await dispatch({
    type: CHANGE_DATE_RANGE,
    payload: limitedDateRange
  });
};


// WEBPACK FOOTER //
// ./src/actions/changeDateRange.js